/*

* @Description: In User Settings Edit
* @Author: your name
* @Date: 2019-08-09 16:41:54
* @LastEditTime: 2019-12-19 10:53:49
* @LastEditTime: 2019-09-09 11:43:43
* @LastEditors: Please set LastEditors
*/

export default {
  general: {
    save: 'सहेजें',
    autosaved: 'स्वत: सहेजा गया',
    back_to: 'वापस',
    by: 'द्वारा',
    chat: 'बातचीत',
    completed: `पूरा: 'हो गया'`,
    canceled: 'रद्द किया गया',
    component: 'कॉम्पोनेन्ट/घटक',
    confirm: 'पुष्टि करें',
    course: 'कोर्स',
    date: 'तारीख',
    details: 'विवरण',
    empty: `कोई आकड़ा उपलब्ध नहीं है`,
    enrolled: 'एनरॉल किया गया',
    free: 'नि: शुल्क',
    graph: 'ग्राफ़',
    loading: 'लोड हो रहा है...',
    lesson: 'पाठ',
    lessons: 'पाठ',
    live_assessment: `लाइव असेसमेंट`,
    live_event: 'लाइव इवेंट',
    no: 'नहीं',
    of: 'का',
    or: 'या',
    organization: 'संगठन',
    page: 'पेज',
    pages: 'पेज',
    personal: 'निजी',
    poll: 'पोल',
    rating: 'रेटिंग',
    reset: 'रीसेट',
    signin: 'साइन इन करें',
    signup: 'साइन अप करें',
    soon: 'जल्द ही',
    type: 'प्रकार',
    uploading: 'अपलोड हो रहा है ...',
    yes: 'हाँ',
    something_went_wrong: 'कुछ गलत हो गया!',
    view_all: 'सभी देखें',
    upload_successful: 'सफलतापूर्वक अपलोड हो गया है',
    upload_successful_message:
      'आपके एक्सेल दस्तावेज़ सफलतापूर्वक अपलोड हो गए हैं और अभी प्रोसेसिंग चल रही हैं। इसमें कुछ समय लग सकता है।',
    check_email_upload_successful:
      'अपलोड किए गए उपयोगकर्ता सूची की <1> रिपोर्ट </ 1> को देखने के लिए कृपया अपना ईमेल </ 0> चेक करें।',
    is_private: 'निजी'
  },

  account: {
    title: 'खाता',
    subtitle: 'अपनी सेटिंग्स और खाता जानकारी को मैनेज करें।',
    saved: 'खाता सफलतापूर्वक बदला गया'
  },

  assessments: {
    title: 'मूल्यांकन',
    subtitle: 'एक मूल्यांकन बनाएँ',
    finished: 'मूल्यांकन समाप्त हो गया है',
    countdown: 'लाइव मूल्यांकन का प्रसारण होगा',
    create: 'मूल्यांकन बनाएँ',
    list_title: 'आपका मूल्यांकन',
    delete_warning: 'क्या आप सच में इस आइटम को हटाना चाहते हैं?',
    details_title: 'मूल्यांकन संबंधित जानकारी जोड़े',
    details_subtitle:
      'अपने मूल्यांकन को नाम दें और अपने दर्शकों को बताएं कि इससे उन्हें क्या सीखने को मिलेगा ।',
    disclaimer: `मैं यह सुनिश्चित करता हूं कि मेरे द्वारा रिकॉर्ड किये गए असेसमेंट नहीं करते है:
  किसी भी तीसरे पक्ष के अधिकारों का उल्लंघन
  - कोई भी अवैधता, जिसमें मानहानि, अश्लील, अभद्र, भद्दी, अश्लील, हिंसक, अपमानजनक,निंदापूर्ण, धमकाने वाला, या भेदभाव करने वाली कोई भी सामग्री शामिल है, यहां तक कि तारांकन के साथ प्रच्छन्न
  - अन्य व्यक्तियों पर कोई व्यक्तिगत हमला
  - अन्य प्रतिभागियों, सार्वजनिक हस्तियों या सेलेब्रिटीज़ पर किसी भी प्रकार का प्रतिरूपण
  - किसी व्यक्ति की सहमति के बिना उससे संबंधित कोई भी रिकॉर्डिंग या व्यक्तिगत जानकारी शामिल है और दुनिया के किसी भी हिस्से में किसी भी डेटा सुरक्षा विनियमन के उल्लंघन नहीं करती है
  - व्यावसायिक लोभ या किसी भी तरह का "स्पैम"'`,
    assessment_details: 'मूल्यांकन का विवरण',

    assessment_settings: 'मूल्यांकन से संबंधित सेटिंग'
  },

  buildersettings: {
    title: 'सेटिंग को सार्वजनिक करें',
    subtitle:
      'आपके ईवेंट को कौन देख सकता और इंटरेक्ट कर सकता है इसकी सेटिंग करे'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'जोड़ें',
    add_page: 'पृष्ठ जोड़ें',
    add_lesson: 'पाठ जोड़े',
    add_answer: 'नया उत्तर जोड़ें',
    add_group: 'समूह जोड़ें',
    add_organization: 'संगठन जोड़ें',
    add_question: 'प्रश्न जोड़ें',
    add_quiz: 'प्रश्नोत्तरी जोड़ें',
    add_users: 'उपयोगकर्ता को जोड़ें',
    back: 'वापस जाये',
    back_to_course: 'कोर्स ओवरव्यू पर वापस जाये',
    back_to_lesson: 'पाठ ओवरव्यू पर वापस जाये',
    back_to_media: 'मीडिया लाइब्रेरी पर वापस जाये',
    back_to_details: 'विवरण पर वापस जाये',
    cancel: 'रद्द करे',
    clear: 'स्पष्ट',
    close: 'बंद करे',
    clone: 'क्लोन',
    close_lesson: 'पाठ बंद करे',
    clone_course: 'क्लोन कोर्स',
    confirm: 'पुष्टि करें',
    create: 'बनाये',
    download: 'डाउनलोड करे',
    download_mass_user_tamplate: 'टेम्पलेट डाउनलोड करें',
    add_mass_users: 'बड़े पैमाने पर उपयोगकर्ताओं को जोड़ें',
    upload_excel_list: 'एक्सेल की सूची अपलोड करें',
    delete: 'मीडिया हटाएं',
    edit: 'बदलाव करे',
    edit_course: 'कोर्स में बदलाव करे',
    enroll: 'एनरॉल करे',
    finish: 'Finish',
    upload_image: 'तस्वीर अपलोड करे',
    upload_image_video: 'तस्वीर या वीडियो अपलोड करे',
    select_media_library: 'मीडिया लाइब्रेरी का चयन करें',
    make_public: 'सार्वजनिक करें',
    make_private: 'निजी रखे',
    make_org: 'संगठन बनाये',
    media: 'मीडिया लाइब्रेरी',
    my_theme: 'मेरी थीम',
    next: 'आगे',
    next_lesson: 'अगला पाठ',
    next_step: 'अगला कदम',
    previous_step: 'पिछला कदम',
    publish: 'सार्वजनिक करे',
    publish_assessment: 'असेसमेंट सार्वजनिक करे',
    publish_course: 'अपना कोर्स सार्वजनिक करें',
    publish_event: 'अपना इवेंट सार्वजनिक करें',
    reset: 'रिसेट करें',
    reset_elements: 'एलिमेंट्स रीसेट करें',
    save: 'सहेजें',
    creating: 'बनाया जा रहा है...',
    updating: 'अपडेट हो रहा है...',
    saved: 'सहेजा गया...',
    save_for_later: 'भविष्य के लिए सहेजे',
    save_settings: 'सेटिंग सहेजे',
    select_files: 'फ़ाइलें चुनें',
    select_theme: 'थीम चुने',
    start_lesson: 'पाठ शुरू करे',
    update: 'अपडेट करें',
    upload: 'अपलोड करे',
    upload_audio: 'ऑडियो अपलोड करें',
    upload_photo: 'प्रोफाइल फोटो अपलोड करें',
    upload_video: 'विडियो अपलोड करें',
    enrolled: 'एनरॉल किया गया',
    unenroll: 'अन-एनरॉल किया गया',
    from_library: 'मिडिया लाइब्रेरी',
    remove: 'हटाये',
    removed: 'हटाया गया',
    start_broadcast: 'प्रसारण शुरू करे',
    end_broadcast: 'प्रसारण रोके',
    camera: 'कैमरा',
    screen: 'स्क्रीन',
    screen_with_camera: 'कैमरा के साथ स्क्रीन',
    insert: 'इन्सर्ट करे',

    inserting: 'इन्सर्ट कर रहे है'
  },

  card: {
    quick_add: 'जल्दी से जोड़े',
    add: 'जोड़े',
    clone: 'क्लोन',
    completed: 'पाठ खत्म हो गए है'
  },

  course: {
    upcoming_course: 'आगामी पाठ्यक्रम',
    unPublishEvent: 'अप्रकाशित इवेंट',
    unPublishAssessment: 'अप्रकाशित असेसमेंट',
    pastCourse: 'प्रशिक्षण पाठ्यक्रम',
    upcoming: 'आगामी लाइव इवेंट',
    pastEvent: 'पिछले लाइव इवेंट',
    pastAssessment: 'पिछले लाइव इवेंट',
    upcomingAssessment: 'आगामी लाइव असेसमेंट',
    created: 'तिथि बनाई गयी:',
    assignees: 'असाइनी',
    organisations: `{{संगठन}} संगठन, <2> {{उपयोगकर्ता}} उपयोगकर्ता </ 2>`,
    event_date: 'लाइव इवेंट की तिथि <1> {{तारीख}} </ 1>',
    delete_warning: 'क्या आप सच मे इसे हटाना चाहते हैं',
    clonning_no_lesson:
      'कृपया इस पाठ्यक्रम का क्लोन बनाने के लिए कम से कम एक पाठ जोड़ें।',
    clone_warning: 'क्या आप सच में इसे क्लोन करना चाहते हैं',
    clone_success: 'क्लोनिंग प्रक्रिया चालू है',
    disclaimer: `मैं यह सुनिश्चित करता हूं कि मेरा कोर्स नहीं करता है:
  किसी भी तीसरे पक्ष के अधिकारों का उल्लंघन
  - कोई भी अवैधता, जिसमें मानहानि, अश्लील, अभद्र, भद्दी, अश्लील, हिंसक, अपमानजनक,निंदापूर्ण, धमकाने वाला, या भेदभाव करने वाली कोई भी सामग्री शामिल है, यहां तक कि तारांकन के साथ प्रच्छन्न
  - अन्य व्यक्तियों पर कोई व्यक्तिगत हमला
  - अन्य प्रतिभागियों, सार्वजनिक हस्तियों या सेलेब्रिटीज़ पर किसी भी प्रकार का प्रतिरूपण
  - किसी व्यक्ति की सहमति के बिना उससे संबंधित कोई भी रिकॉर्डिंग या व्यक्तिगत जानकारी शामिल है और दुनिया के किसी भी हिस्से में किसी भी डेटा सुरक्षा विनियमन के उल्लंघन नहीं करती है
  - व्यावसायिक लोभ या किसी भी तरह का "स्पैम”`
  },
  coursecreate: {
    dropzone_text: 'मीडिया डालें',
    sidebar_text: 'अपने <3 /> सभी पाठो के लिए एक थीम <1 /> चुनें',
    delete_warning: 'क्या आप सच में इस पाठ को हटाना चाहते हैं?'
  },

  coursepage: {
    Quizview_loading: 'उत्तरों की जाँच की जा रही है। कृपया प्रतीक्षा करें...',
    Quizview_answer: 'आपका उत्तर'
  },

  coursequiz: {
    title: 'हर पाठ के साथ क्विज'
  },

  dashboard: {
    tooltip_title: 'इस वीडियो को फिर से न दिखाएं',
    page_title: 'आपके पाठ्यक्रम का आँकड़ा',
    page_subtitle: 'आपके द्वारा बनाए गए पाठ्यक्रमों की स्थिति',
    profile_add_info:
      'अपना प्रोफ़ाइल को पूरा करने के लिए <1> {{अनकंप्लीटेक्स्ट}} </ 1> जोड़ें।',
    profile_build:
      'अपनी प्रोफ़ाइल बनाएं <1> यहां </ 1>, हमें अपनी रुचियों और कौशल के बारे में बताएं।',
    profile_title: 'प्रोफाइल स्ट्रेंथ',
    more_details: 'अधिक जानकारी'
  },

  errors: {
    answer: 'कृपया उत्तर दर्ज करे',
    answer_correct: 'सही उत्तर चुने',
    code: 'कृपया अपना कोड दर्ज करे',
    criterion: 'कृपया मापदंड तय करे',
    duration: 'अवधि भरना आवश्यक है',
    element: 'कृपया एलिमेंट दर्ज करे',
    email: 'कृपया अपना ईमेल दर्ज करेl',
    email_invalid: 'यह ईमेल मान्य नहीं हैl',
    feedback_correct: 'कृपया सही फ़ीडबैक चुने',
    feedback_incorrect: 'कृपया गलत फ़ीडबैक चुने',
    host: 'कृपया इवेंट होस्ट दर्ज करे',
    host_assessment: 'कृपया मूल्यांकन के मेजबान को दर्ज करे',
    image: 'कृपया एक चित्र अपलोड करें',
    location: 'कृपया अपना स्थान दर्ज करें',
    live_location: 'कृपया प्रसारण का एक स्थान चुनें',
    limit: 'कृपया लाइव-स्ट्रीमिंग की मिनट दर्ज करे',
    min_3char: 'न्यूनतम 3 वर्ण',
    number: 'कृपया पॉजिटिव संख्या ही दर्ज करें।',
    host_email_require: `होस्ट का ईमेल दर्ज करना आवश्यक हैं।`,
    attendee_email_require: `अटेंडी का ईमेल दर्ज करना आवश्यक हैं।`,
    name: 'कृपया अपना नाम दर्ज करें',
    not_found_course: 'कोर्स नहीं मिला',
    not_found_event: 'ईवेंट नहीं मिला',
    not_found_assessment: 'आकलन नहीं मिला',
    password: 'कृपया अपना पासवर्ड दर्ज करें',
    password_digit: 'कम से कम एक अंक',
    password_short: 'पासवर्ड बहुत छोटा है, न्यूनतम 10 वर्ण दर्ज करे',
    password_special: 'कम से कम एक विशेष कॅरक्टर',
    password_uppercase: 'कम से कम एक अपरकेस कॅरक्टर',
    password_lowercase: 'कम से कम एक लोअरकेस कॅरक्टर',
    phone: 'कृपया अपना फ़ोन नंबर दर्ज करें',
    phone_invalid: 'अमान्य फ़ोन नंबर',
    status: 'कृपया अपना स्थान दर्ज करें',
    question: 'कृपया प्रश्न दर्ज करे',
    start_date: 'आरंभ तिथि और समय आवश्यक है',
    tag: 'कृपया एक टैग का चयन करें',
    topics: 'कृपया कम से कम एक विषय का चयन करें।',
    live_topics: 'कृपया विषय जोड़ें',
    title: 'कृपया शीर्षक दे',
    title_assessment: 'कृपया असेसमेंट का शीर्षक दे',
    title_course: 'कृपया कोर्स का शीर्षक दे',
    title_empty: 'शीर्षक खाली नहीं हो सकता',
    title_event: 'कृपया ईवेंट का शीर्षक दे',
    title_lesson: 'कृपया पाठ शीर्षक दे',
    title_quiz: 'कृपया प्रश्नोत्तरी को नाम दे',
    username: 'कृपया अपना यूजरनेम दर्ज करें',
    upload_error: 'त्रुटि - फ़ाइल अनुकूल नहीं है!',
    upload_more_than_10:
      'आप केवल एक बार में अधिकतम 10 फ़ाइलें अपलोड कर सकते हैं।',
    topic_max: 'कृपया अधिकतम 3 विषय ही जोड़ें।',
    upload_excel: 'कृपया सुनिश्चित करें कि आपने सही फ़ाइल अपलोड की है।',
    title_excel: 'टेम्प्लेट अपलोड करने में त्रुटि आ रही है:',
    file_size_exceed: 'फ़ाइल का आकार तय सीमा सेँ अधिक है',
    subtitle_excel:
      'कृपया सुनिश्चित करें कि आपने दिए किए गए टेम्पलेट का उपयोग किया हो और कॉलम भी सही ढंग से भरे हो।',
    select_broadcast_option:
      'कृपया इस घटना को प्रसारित करने के लिए एक विकल्प चुनें',
    multi_hosts_number_error:
      'इवेंट की तय सीमा से अधिक प्रस्तुतकर्ता नहीं हो सकते है।',
    conference_people_number_error:
      'इवेंट की तय सीमा से अधिक प्रतिभागी नहीं हो सकते है।',
    select_max_host: 'इवेंट के लिए कम से कम 1 प्रस्तुतकर्ता का चयन करें।',
    select_max_conference: 'इवेंट के लिए कम से कम 1 प्रतिभागी का चयन करें।',
    stream_stop_error: 'स्ट्रीमिंग अचानक से रुक गयी!',
    unsecure_context:
      'बड़ी त्रुटि: असुरक्षित कंटेंट के कारण ब्राउज़र कैमरा और माइक का उपयोग नहीं कर सकता है। कृपया एचटीटीपीएस के जरिये एसएसएल इंसटाल करें  ',
    ws_not_supported: 'बड़ी त्रुटि: यह ब्राउज़र वेबसॉकेट को स्पोर्ट नहीं करता है',
    no_org: 'आगे बढ़ने के लिए कम से कम 1 संगठन का चयन करें।',
    no_org_group: 'आगे बढ़ने के लिए कम से कम 1 संगठन समूह का चयन करें।',
    waiting_to_join: 'किसी के शामिल होने का इंतजार!'
  },

  events: {
    title: 'लाइव इवेंट की जानकारी दे',
    change_host: 'होस्ट बदलें',
    finished: 'इवेंट समाप्त हो गई है',
    countdown: 'लाइव इवेंट प्रसारित होगा',
    subtitle:
      'अपने लाइव इवेंट को एक नाम दें और अपने दर्शकों को बताएं कि इससे उन्हें क्या सीखने को मिलेगा।',
    poll_disabled: 'इस इवेंट के लिए पोल ​​उपलब्ध नहीं है',
    disclaimer: `मैं यह सुनिश्चित करता हूं कि यह लाइव इवेंट नहीं करता है:
  किसी भी तीसरे पक्ष के अधिकारों का उल्लंघन
  - कोई भी अवैधता, जिसमें मानहानि, अश्लील, अभद्र, भद्दी, अश्लील, हिंसक, अपमानजनक,निंदापूर्ण, धमकाने वाला, या भेदभाव करने वाली कोई भी सामग्री शामिल है, यहां तक कि तारांकन के साथ प्रच्छन्न
  - अन्य व्यक्तियों पर कोई व्यक्तिगत हमला
  - अन्य प्रतिभागियों, सार्वजनिक हस्तियों या सेलेब्रिटीज़ पर किसी भी प्रकार का प्रतिरूपण
  - किसी व्यक्ति की सहमति के बिना उससे संबंधित कोई भी रिकॉर्डिंग या व्यक्तिगत जानकारी शामिल है और दुनिया के किसी भी हिस्से में किसी भी डेटा सुरक्षा विनियमन के उल्लंघन नहीं करती है
  - व्यावसायिक लोभ या किसी भी तरह का "स्पैम”`,
    prompt_message:
      'इस पेज से वापस जाने पर आपका इवेंट समाप्त हो जाएगा। क्या आप फिर भी इस पेज से जाना चाहते हैं? ',
    duration_exceed_message:
      'आपका प्रसारण समय तय सीमा को पार कर गया है, ऐप प्रसारण बंद करने जा रहा है।',
    before_schedule_message:
      'आप निर्धारित कार्यक्रम के समय से पहले प्रसारण शुरू करने जा रहे हैं। कृपया ध्यान दें कि प्रसारण बंद करने से इवेंट भी रुक जाएगा। ',
    browser_unsupportive_message:
      'आपका ब्राउज़र स्क्रीन शेयर को स्पोर्ट नहीं करता है। आप इस लिंक पर जाकर स्पोर्ट करने वाले ब्राउज़र डाउनलोड कर सकते हैं',
    cancel_switch_host_message:
      'होस्ट उपलब्ध नहीं है। आपकी ओर से इवेंट जारी रहेगा।',
    coaching_prompt_message: 'इवेंट खत्म होने तक आप इस पेज से नहीं जा सकते।',
    event_modal_warn: 'क्या आप इस इवेंट से बाहर निकलना चाहते हैं?',
    confirm_message: 'ठीक है पर क्लिक करने से आपका ईवेंट यही खत्म हो जाएगा।',
    screen_share_denied: 'आपने अपनी स्क्रीन साझा करने से इनकार कर दिया।',
    media_not_found:
      'आपके डिवाइस की कैमरा या माइक उपलब्ध नहीं है या आपके द्वारा इन्हे एक्सेस करने की अनुमति नहीं दी गयी।',
    media_not_access:
      'कैमरा या माइक का उपयोग कुछ अन्य प्रक्रियाओ के लिए किया जा रहा है जिससे डिवाइस को मैनेज नहीं किया जा रहा है। ',
    constraint_error:
      'ऐसा कोई उपकरण नहीं मिला है जो आपके वीडियो और ऑडियो की कमी को पूरा कर सके। आप चाहे तो वीडियो और ऑडियो बाधाओं को बदल सकते हैं।',
    media_access_denied: 'आपको कैमरा और माइक एक्सेस करने की अनुमति नहीं है।'
  },

  filters: {
    days7: 'अंतिम 7 दिन',
    days15: 'अंतिम 15 दिन',
    days30: 'अंतिम 30 दिन',
    days365: 'अंतिम 365 दिन',
    date: 'तारीख तय की गयी',
    relevance: 'उपयोग',
    popularity: 'लोकप्रियता',
    name: 'नाम',
    group: 'समूह',
    Newest_to_Oldest: 'सबसे नए से सबसे पुराना',
    Oldest_to_Newest: 'सबसे पुराने से सबसे नया',
    A_Z: 'A to Z',
    Z_A: 'Z to A'
  },

  helpers: {
    password:
      'आपके खाते की सुरक्षा को मद्देनजर रखते हुए आपके पासवर्ड में कम से कम एक लोअरकेस और एक संख्या होना आवश्यक है। पासवर्ड में न्यूनतम 10 वर्ण  होने चाहिए। ',
    phone: 'कृपया अपना फ़ोन कंट्री कोड भरे, उदाहरण के लिए: +65',
    username:
      'आपके यूजरनेम को सार्वजनिक जानकारी के रूप में माना जाता है और आवश्यकता पड़ने पर इसे अन्य यूजर के साथ भी साझा किया जा सकता है। इसलिए, हम उम्मीद करते हैं कि आप अपने यूजरनेम में किसी निजी जानकारी का उपयोग न करें ',
    public_description_normal:
      'आपका <0> <0 /> </ 0> सहेजा जा चूका है और डिफ़ॉल्ट रूप से इसे निजी किया गया है। इसका मतलब है कि केवल आप इस कंटेंट को देख सकते हैं। इस कंटेंट को सार्वजनिक करने के लिए आप नीचे दिए गए विकल्पों में से एक का चयन कर सकते हैं। अपने पाठ्यक्रम को सार्वजनिक करने का अर्थ है कि इस प्लॅटफॉर्म पर मौजूद सभी यूजर आपका कंटेंट एक्सेस कर सकते है। विशिष्ट यूजर विकल्प आपको अपने मनचाहे यूजर के शेयरवेयर खाते से जुड़े ईमेल पते का उपयोग करके उसके साथ अपना पाठ्यक्रम साझा करने का मौका देता है। ',
    public_description_admin:
      'आपका <0> <0 /> </ 0> सहेजा जा चूका है और डिफ़ॉल्ट रूप से इसे निजी किया गया है। इसका मतलब है कि केवल आप (और कंटेंट क्रिएटर) इस कंटेंट को देख सकते हैं। इस कंटेंट को सार्वजनिक करने के लिए आप नीचे दिए गए विकल्पों में से एक का चयन कर सकते हैं। अपने पाठ्यक्रम को सार्वजनिक करने का अर्थ है कि इस प्लॅटफॉर्म पर मौजूद सभी यूजर आपका कंटेंट एक्सेस कर सकते है।  - जिसमें आपके संगठन के बाहर के लोग भी शामिल होंगे। इसे संगठन के साथ सार्वजनिक करने का अर्थ है कि संगठन के भीतर मौजूद सभी यूजर इसे देख पाएंगे। आप इसे 1 या अधिक समूहों के बीच भी सार्वजनिक कर सकते हैं, जिसका अर्थ है कि केवल उन समूहों के उपयोगकर्ता ही इसे देख पाएंगे। अंत में, आपके पास एक और विकल्प है जिसकी सहायता से आप अपने संगठन के भीतर और कुछ बाहरी यूजर के समक्ष अपना पाठ्क्रम सार्वजनिक कर सकते है। इसे करने के लिए आपको उनके शेयरलुक खाते से जुड़े ईमेल पते की जरूरत होगी। '
  },

  labels: {
    add: 'जोड़ें',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'उत्तर दर्ज करे',
    answers: 'उत्तर',
    back_to_quiz: 'प्रश्नोत्तरी की सूची पर वापस जाये',
    back_to_question: 'प्रश्न सूची पर वापस',
    chat: 'चैट',
    chat_available: 'इस इवेंट में चैट उपलब्ध नहीं है',
    chat_report: 'चैट की रिपोर्ट',
    choice_single: 'एकमात्र विकल्प',
    choice_multiple: 'बहुविकल्पी',
    choice_free: 'नि: शुल्क विकल्प',
    choice_sorting: 'विकल्प छांटे',
    choice_matrix: '"मैट्रिक्स छांटने" का विकल्प',
    clone_lesson_permission: 'क्लोन की अनुमति',
    code: 'कोड',
    correct: 'सही',
    created: 'तारीख तय की गयी',
    clone_modal: 'क्लोन कोर्स',
    cloning_course: 'क्लोनिंग कोर्स ...',
    cloning: 'क्लोनिंग ...',
    cloning_course_desc:
      'इस प्रक्रिया में कुछ समय लग सकता है। कृपया धैर्य बनाये रखें',
    cloning_success: 'कोर्स "<0 />" का क्लोन बनाया गया!',
    description: 'विवरण',
    disclaimer: 'अस्वीकरण',
    drop_file: 'फाइल यहाँ उपलोड करे...',
    duration: 'अवधि',
    edit: 'बदलाव करें',
    email: 'ईमेल',
    event: 'इवेंट',
    event_all: 'सभी इवेंट',
    event_date: 'लाइव इवेंट का लोकल समय /तारीख',
    event_this: 'यह इवेंट',
    expire: 'को खत्म होगा',
    expiry_date: 'समाप्ति की तारीख',
    forgot: 'पासवर्ड भूल गए?',
    group: 'समूह',
    groups_list: 'समूह की सूची',
    host: 'होस्ट',
    id_annotation: 'एनोटेशन आईडी',
    id_quiz: 'क्विज़ आईडी',
    incorrect: 'गलत',
    interests: 'रुचियां',
    invited: 'आमंत्रित किया गया',
    live_chat: 'लाइव चर्चा',
    live_stream_limit: 'लाइव-स्ट्रीमिंग की मिनट',
    contact_text: 'अपनी मासिक लाइव-स्ट्रीमिंग सीमा को बदलने के लिए संपर्क करें',
    contact_admin:
      '<0> यदि आप अपनी मासिक लाइव-स्ट्रीमिंग सीमा बदलना चाहते हैं तो यहाँ संपर्क करें </ 0> <1> admin@sharelook.com </ 1>',
    limit_stream_text:
      'Live-streaming Minutes Remaining: <0> {{सीमा}} </ 0> मिनट <1 /> <2 /> <3> अपनी मासिक लाइव-स्ट्रीमिंग सीमा को बदलने के लिए कृपया संपर्क करें </ 3> <4> व्यवस्थापक @ sharelook.com </ 4> ',
    location: 'लोकेशन',
    lessons: 'पाठ',
    location_broadcast: 'होस्ट सर्वर की लोकेशन',
    location_broadcast_subtitle:
      'ऑडिओ विज़ुअल डिले को कम करने के लिए प्रसारण होस्ट की लोकेशन के नजदीक एक लोकेशन जोड़े',
    Media_manager: 'मीडिया मैनेजर',
    minutes: 'मिनट',
    name: 'नाम',
    online_quiz: 'ऑनलाइन क्विज़',
    organiser: 'लेखक',
    organization: 'संगठन',
    overall_emotion: 'समग्र अनुभव:',
    organizations_list: 'संगठनों की सूची',
    password: 'पासवर्ड',
    participants: 'प्रतिभागी',
    picture: 'चित्र (16: 9)',
    phone: 'फ़ोन',
    photo: 'फोटो',
    poll: 'पोल',
    position: 'पोजीशन',
    processing: 'प्रोसेस हो रहा है',
    privacy_settings: 'गोपनीय सेटिंग्स',
    question: 'प्रश्न',
    quiz_create: 'नई प्रश्नोत्तरी बनाएं',
    quiz_name: 'प्रश्नोत्तरी का नाम',
    quiz_update: 'क्विज़ अपडेट करें',
    select_organization: 'एक संगठन का चयन करें',
    settings: 'सेटिंग्स',
    show: 'दिखाएं',
    show_graph: 'ग्राफ के परिणाम दिखाएं',
    signin: 'साइन इन करे',
    signup: 'साइन अप करें',
    sort_by: 'द्वारा क्रमबद्ध करें',
    start_date: 'शुरू होने की तारीख',
    tags: 'टैग',
    terms: 'मैं इन <1> नियमों और शर्तों से सहमत हूं </ 1>।',
    title: 'शीर्षक',
    topics: 'विषय',
    topic: 'विषय',
    total_comments: 'कुल टिप्पणियाँ',
    username: 'उपयोगकर्ता का नाम',
    users_list: 'उपयोगकर्ताओं की सूची',
    users_emails: 'खास उपयोगकर्ताओ के ईमेल दर्ज करे',
    description_specifiction_email:
      'कृपया एक से अधिक खास उपयोगकर्ताओं के साथ इसे साझा करने के लिए प्रति पंक्ति में 1 ईमेल पता दर्ज करें।',
    message_specific_email: 'कृपया विशेष उपयोगकर्ता का ईमेल दर्ज करें।',
    viewers: 'दर्शक',
    edit_course: 'बदलाव करें',
    edit_assessment: 'बदलाव करें',
    edit_event: 'बदलाव करें',
    delete_course: 'हटाएँ',
    delete_event: 'हटाएँ',
    delete_assessment: 'हटाएँ',
    view_course: 'देखें',
    view_event: 'देखें',
    view_assessment: 'देखें',
    date_event: 'लाइव इवेंट की तारीख',
    date_assessment: 'लाइव असेसमेंट की तारीख',
    clone_of: 'क्लोन',
    clone_course:
      'इस पाठ्यक्रम का एक क्लोन बनाएं जिसमें आप स्वतंत्र रूप से बदलाव कर सकते हैं, जिसमें सभी पाठ और पृष्ठ शामिल हैं।',
    make: 'बनाएं',
    available_to: 'किसी भी शेयरलुक यूजर के लिए उपलब्ध',
    uploaded_by: 'द्वारा अपलोड किया गया:',
    course: 'कोर्स',
    assessment: ' मूल्यांकन',
    user_not_exist: 'यूजर मौजूद नहीं है, क्या आप निमंत्रण भेजना चाहेंगे?',
    check_user: 'नोटिस',
    user_not_exist_in_org:
      'यूजर इस संगठन में मौजूद नहीं है, क्या आप निमंत्रण भेजना चाहेंगे?',
    title_modal_stream: 'ऑर्गनाइजेशन लाइवस्ट्रीम लिमिट में बदलाव करे',
    des_warning_stream: 'आप बदलने वाले हैं',
    monthly_stream: 'मासिक लाइव-स्ट्रीमिंग सीमा',
    min_per_month: 'मिनटे/ माह',
    broadcast_label: 'मैं करना चाहता हूं:',
    hosts_emails: 'विशिष्ट होस्ट का ईमेल दर्ज करे',
    attendee_emails: 'विशिष्ट प्रतिभागी के ईमेल दर्ज करे',
    description_host_specifiction_email:
      'कृपया प्रति पंक्ति में 1 ईमेल पता दर्ज करें।',
    presenter_label: 'प्रस्तुतकर्ता',
    presenter_label_conference: 'लोगो की संख्या',
    event_privacy: 'कांफ्रेंस मोड़'
  },

  broadcastOptions: {
    wowza_gocoder: 'मेरे फोन से सीधा लाइव प्रसारण करे',
    other_webrtc: 'मेरे पीसी से वेबिनार करे',
    multihost: 'मेरे पीसी से मल्टीकास्ट वेबिनार करे',
    peer2peer: 'कोचिंग सेशन',
    conference: 'लाइव कांफ्रेंस'
  },

  lessoncreate: {
    title: 'पाठ से संबंधित जानकारी दे',
    subtitle:
      'अपने पाठ का नाम दें और अपने दर्शकों को बताएं कि इससे उन्हें क्या सीखने को मिलेगा',
    input_label_title: 'पाठ का शीर्षक',
    input_label_topics: 'पाठ का विषय',
    input_label_description: 'पाठ का विवरण',
    delete_warning: 'क्या आप सच में इस पेज को मिटाना चाहते है ?'
  },

  lessonoverview: {
    title: 'पाठ जोड़ें',
    subtitle: 'मौजूदा पाठ जोड़ें या एक नया बनाएं',
    new_lesson: 'एक नया पाठ बनाएँ',
    new_lesson_sub: 'स्क्रैच से एक नया पाठ बनाएँ!',
    existing_lesson: 'मौजूदा पाठ का चयन करें',
    existing_lesson_sub:
      'मौजूदा पाठ का लिंक, इस पाठ में किए गए परिवर्तन से अन्य पाठ्यक्रमों में भी इसी पाठ पर प्रभाव पड़ेगा',
    clone_lesson: 'मौजूदा पाठ की नकल करके एक ओर ऐसा ही पाठ बनाये',
    clone_lesson_sub:
      'इस पाठ्यक्रम के पाठ की एक कॉपी बनाये , इस पाठ में किए गए परिवर्तन मूल पाठ को प्रभावित नहीं करेंगे',
    clone_lesson_modal_sub:
      'कृपया अपने मनचाहे पाठ को जोड़ने के लिए उसके नीचे दिए गए क्लोन बटन पर क्लिक करें'
  },

  management: {
    groups_title: 'समूहों को मैनेज करें',
    delete_warning: 'क्या आपको यकीन है?',
    organizations_title: 'मेरे संगठन',
    organizations_subtitle: 'संगठनों को अपनी सूची में जोड़ें',
    users_title: 'यूजर को मैनेज करें',
    users_position: 'वरिष्ठ खाता प्रबंधक',
    user_not_found: 'यूजर नहीं मिला',
    select_org:
      'कृपया उपयोगकर्ताओं को प्रबंधित करने के लिए एक संगठन खोजें और चुनें'
  },

  audio: {
    modal_title: 'ऑडियो अपलोड करें ',
    list_view: 'लिस्ट व्यू',
    create_audio_modal_title: 'ऑडियो बनाएँ',
    edit_audio_modal_title: 'ऑडियो में बदलाव',
    public_audio_not_found: 'ऑडियो नहीं मिला ',
    Private_audio_not_found: 'आपने अभी तक कोई ऑडियो अपलोड नहीं किया है',
    are_you_sure_to_delete: 'क्या आप वाकई हटाना चाहते हैं?',
    type_something: 'कुछ टाइप करे',
    select_voice: 'चुने',
    file_name: 'फ़ाइल का नाम',
    description: 'विवरण',
    topic: 'विषय',
    key_words_tag: 'कीवर्ड्स को टैग बनाये',
    mp3_audio: 'एमपी 3 ऑडियो',
    created: 'बनाया',
    duration: 'अवधि',
    close: ' बंद करे'
  },

  image: {
    modal_title: 'चित्र अपलोड करे',
    image: 'चित्र ',
    pixel: 'पिक्सेल',
    dimension: 'आयाम',
    public_image_not_found: 'चित्र नहीं मिला।',
    Private_image_not_found: 'आपने अभी तक कोई छवि अपलोड नहीं की है'
  },

  annotation: {
    modal_title: 'एनोटेशन'
  },

  text: {
    modal_title: 'टेक्स्ट एडिटर'
  },

  video: {
    modal_title: 'वीडियो अपलोड करे',
    image: ' वीडियो ',
    mp4_video: 'MP4 वीडियो ',
    public_video_not_found: 'वीडियो नहीं मिली',
    private_video_not_found: 'आपने अभी तक कोई वीडियो अपलोड नहीं की है'
  },

  media: {
    title: 'मीडिया लाइब्रेरी',
    subtitle: 'आपकी फाइलों की लाइब्रेरी',
    modal_title: 'मीडिया उपलोड करे',
    delete_warning: 'डिलीट कन्फर्म करे',
    delete_message:
      'डिलीट किया हुए मीडिया को आपने जिन भी पेजो पर इस्तेमाल किया है वो वहाँ से नहीं हटेंगे',
    dropzone_text: 'ड्रैग या ड्राप करे ',
    delete_success: ' मीडिया को सफलतापूर्वक डिलीट किया गया',
    upload_file: 'फाइल उपलोड करे',
    drag_drop: 'ड्रैग या ड्राप करे',
    import_file: 'कंप्यूटर से फाइल उपलोड करे',
    no_media: 'आपने अभी तक कोई मीडिया अपलोड नहीं किया है',
    media_type: 'मीडिया का प्रकार',
    video: 'वीडियो',
    image: 'चित्र',
    audio: 'ऑडियो',
    gif: 'GIF/जीआईऍफ़  ',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'मीडिया नहीं है',
    of: 'of',
    disclaimer: `मैं यह सुनिश्चित करता हूं कि यह मिडिया इवेंट नहीं करता है:
  किसी भी तीसरे पक्ष के अधिकारों का उल्लंघन
  - कोई भी अवैधता, जिसमें मानहानि, अश्लील, अभद्र, भद्दी, अश्लील, हिंसक, अपमानजनक,निंदापूर्ण, धमकाने वाला, या भेदभाव करने वाली कोई भी सामग्री शामिल है, यहां तक कि तारांकन के साथ प्रच्छन्न
  - अन्य व्यक्तियों पर कोई व्यक्तिगत हमला
  - अन्य प्रतिभागियों, सार्वजनिक हस्तियों या सेलेब्रिटीज़ पर किसी भी प्रकार का प्रतिरूपण
  - किसी व्यक्ति की सहमति के बिना उससे संबंधित कोई भी रिकॉर्डिंग या व्यक्तिगत जानकारी शामिल है और दुनिया के किसी भी हिस्से में किसी भी डेटा सुरक्षा विनियमन के उल्लंघन नहीं करती है
  - व्यावसायिक लोभ या किसी भी तरह का "स्पैम”`,
    my_media: 'मेरा मीडिया',
    public_library: 'पब्लिक लाइब्रेरी',
    organization_library: 'संगठन की लाइब्रेरी ',
    upload_from_computer: 'कंप्यूटर से अपलोड करे',

    create: 'क्रिएट करे',
    all: 'सभी',
    male: 'पुरुष ',
    female: ' महिला',
    processing_audio: 'ऑडियो प्रोसेस हो रही है',

    create_annotation: 'एनोटेशन बनाएं',
    popup_over_lesson_text:
      'क्लिक करने के बाद एनोटेशन पाठ के पृष्ठ पर पॉप अप होगा',
    edit_detail: 'विवरण में बदलाव करे',

    delete: 'हटाएं',

    go_create_audio: 'आइये , ऑडियो बनाएँ',

    show_more_details: 'अधिक विवरण दिखाएं',

    show_less_details: 'कम विवरण दिखाएं',

    drop_files: 'सही जगह फाइल अपलोड करे',
    or: 'या',
    import_files: 'कंप्यूटर से फ़ाइलें अपलोड करें'
  },

  navigation: {
    account: 'खाता',
    assessments: 'मूल्यांकन',
    dashboard: 'डैशबोर्ड',
    groups: 'समूह प्रबंधन',
    logout: 'लॉग आउट',
    organisations: 'संगठन',
    organizations_users: 'संगठन और उपयोगकर्ता',
    reports: 'रिपोर्ट',
    schedule: 'अनुसूची',
    training: 'प्रशिक्षण',
    nowLive: 'लाइव',
    users: 'उपयोगकर्ता',
    workshop: 'मेरी कार्यशाला'
  },

  onboarding: {
    step1_title: 'चरण 1: हमें अपने बारे में थोड़ा बताएं',
    step1_subtitle: 'आपका नाम क्या हे? आप कहां के निवासी हैं? आप क्या करते है?',
    step2_title: 'चरण 2: आप जिस कौशल में सुधर करना चाहते उसका चयन करें',
    step2_subtitle:
      'इसके बाद, हमें बताएं कि आप किस बारे में और बेहतर तरिके से समझना चाहेंगे। हमे उम्मीद है ऐसा कुछ न कुछ जरूर होगा? अध्ययन का एक नया क्षेत्र? आपके प्रिय व्यक्ति क्या करते है? '
  },

  pagebuilder: {
    title: 'एक पाठ तैयार करे ',
    subtitle:
      'अब समय आ गया है कि आपके दर्शक आपसे कुछ सिख पाए, इसके लिए आप तस्वीर, वीडियो और इन्फोग्राफिक्स का इस्तेमाल कर सकते हैं',
    select_layout: 'एक पेज लेआउट चुनें',
    template1: 'ब्लैंक',
    template2: 'शीर्षक और उपशीर्षक',
    template3: 'शीर्षक और पाठ',
    template4: 'शीर्षक, मीडिया और पाठ',
    template5: 'शीर्षक और मीडिया',
    template6: 'शीर्षक और प्रश्नोत्तरी'
  },

  pageconstructor: {
    title: 'पाठ तैयार करे और क्लोन बनाये',
    subtitle:
      'अब समय आ गया है कि आपके दर्शक आपसे कुछ सिख पाए, इसके लिए आप तस्वीर, वीडियो और इन्फोग्राफिक्स का इस्तेमाल कर सकते हैं'
  },

  passwordreset: {
    success_coded:
      'हमने आपके दिए गए पते पर एक पुष्टिकरण कोड ईमेल किया है, कृपया एक नया पासवर्ड सेट करने के लिए नीचे दिए गए फ़ील्ड में कोड कॉपी करे।',
    success_changed:
      'आपने सफलतापूर्वक एक नया पासवर्ड सेट किया है। अब आप साइन इन कर सकते हैं। '
  },

  placeholders: {
    search: 'खोजे',
    answer: 'उत्तर',
    chat: 'कुछ कहे ...',
    code: 'कोड',
    criterion: 'मापदंड',
    date_event: 'तारीख और समय का चयन करे ',
    date_start: 'शुरु होने की तारीख',
    date_expire: 'समाप्ति की तारीख',
    description: 'विवरण',
    elements: 'चीजों को क्रमबद्ध करें',
    email: 'ईमेल',
    feedback_correct: 'सही फीडबैक',
    feedback_incorrect: 'गलत फीडबैक',
    host: 'होस्ट',
    keywords: 'कीवर्ड खोजे',
    lesson_description: 'पाठ का विवरण',
    location: 'लोकेशन',
    minutes: 'मिनटे',
    name: 'नाम',
    organiser: 'लेखक',
    organization: 'संगठन',
    password: 'पासवर्ड',
    phone: 'फ़ोन',
    photo: 'फोटो',
    picture: 'चित्र',
    point: 'बिंदु',
    position: 'पोजीशन',
    question: 'सवाल',
    quiz: 'प्रश्नोत्तरी का नाम',
    search_course: 'कोर्स खोजें',
    search_media: 'मीडिया खोजें',
    search_name: 'नाम से खोजें',
    search_title: 'शीर्षक से खोजें',
    search_training: 'प्रशिक्षण खोजे',
    settings: 'सेटिंग्स',
    tags: 'टैग',
    title: 'शीर्षक',
    topics: 'विषय',
    username: 'यूजरनेम',
    keyword: 'कीवर्ड',
    max_500_characters: 'अधिकतम 500 वर्ण',
    no_description: 'इस फ़ाइल का विवरण नहीं है',
    no_keyword: 'इस फ़ाइल में कोई कीवर्ड नहीं है',
    no_topics: 'इस फ़ाइल में विषय सेट नहीं है',
    feedback: 'संदेश',
    contact: 'हम कैसे मदद कर सकते हैं?'
  },

  publishsettings: {
    title: 'सेटिंग सार्वजनिक करे ',
    event_subtitle:
      'आपके ईवेंट को कौन देख सकता है और कौन इंटरेक्ट कर सकता है उसकी सेटिंग करे',
    assessment_subtitile:
      'अपने असेसमेंट का नाम दें और अपने दर्शकों को बताएं कि इससे उन्हें क्या सीखने को मिलेगा',
    course_subtitle:
      'आपके कोर्स को कौन देख सकता है और कौन इंटरेक्ट कर सकता है उसकी सेटिंग करे',
    disclaimer: `1. पंजीकरण

  यदि आप एक यूजर के रूप में पंजीकरण करते / एक खाता बनाते तो मान लिया जायेगा कि आप हमारे [यूजर समझौते] से सहमत हैं और आप हमारी [गोपनीयता नीति] को भी पढ़ चुके हैं।


2. कोर्स क्रिएट करना

  यदि आप हमारे टूल का उपयोग करके कोर्स क्रिएट करते है, तो  माना लिया जायेगा कि आप हमारे [यूजर एग्रीमेंट] से सहमत होते हैं और आप हमारी [गोपनीयता नीति] को भी पढ़ चुके हैं।


3. इवेंट क्रिएट करना

  यदि आप हमारे टूल का उपयोग करके इवेंट क्रिएट करते है, तो मान लिया जायेगा कि आप हमारे [यूजर एग्रीमेंट] से सहमत होते हैं और आप हमारी [गोपनीयता नीति] को भी पढ़ चुके हैं।

4. असेसमेंट क्रिएट करना

  यदि आप हमारे टूल का उपयोग करके असेसमेंट क्रिएट करते है, तो मान लिया जायेगा कि आप हमारे [यूजर एग्रीमेंट] से सहमत होते हैं और आप हमारी [गोपनीयता नीति] को भी पढ़ चुके हैं।`,
    dates_validation_error: 'दोनों तारीखें भरनी होंगी',
    email_validation_error: 'ईमेल की सूची अमान्य है',
    specific_email_validation_error: 'केवल एक ईमेल की अनुमति है',
    i_agree_to_these: 'मैं इनसे सहमत हूं',
    terms_and_conditions: 'नियम और शर्तें',
    PublicDescription:
      'नि: शुल्क स्वतंत्र यूजर: (निजी और सार्वजनिक विकल्प) आपका [कोर्स | इवेंट | असेसमेंट] सहेजा गया है और डिफ़ॉल्ट रूप से इसे निजी माना जाता है। इसका मतलब है कि केवल आप इस कंटेंट को देख सकते हैं। इस कंटेंट को सार्वजनिक करने के लिए आप इसे नीचे सार्वजनिक करना चुन सकते हैं। इसका मतलब है कि अब प्लेटफार्म पर मौजूद सभी उपयोगकर्ताओं आपके कंटेंट को देख सकेंगे।',
    OrganisationsDescription:
      'संगठन के उपयोगकर्ता: ("" समाप्त "" के बजाय "" "प्रकाशित करें" का उपयोग करें) और अन्य उपयोगकर्ताओं की तरह ही प्रकाशित पृष्ठ पर लाएं, लेकिन किसी भी प्रकाशित विकल्प का उपयोग किये बिना।) आपका [कोर्स | इवेंट | असेसमेंट] सहेजा जा चूका और निजी रखा गया है। इसका मतलब है कि केवल आप और आपके संगठन के व्यवस्थापक ही इसे देख सकते हैं। एक उपयोगकर्ता के लिहाज से , आप अपने संगठन के भीतर अपनी सामग्री को स्वयं प्रकाशित नहीं कर सकते क्योंकि इसके लिए व्यवस्थापक अधिकारों की आवश्यकता होती है। कृपया अपने किसी व्यवस्थापक से संपर्क करें और उन्हें अपनी सामग्री को सार्वजनिक तौर पर, पूरे संगठन के बीच, आपके संगठन के विशिष्ट समूहों के बीच या विशिष्ट उपयोगकर्ताओं के समक्ष प्रकाशित करने के लिए अनुरोध करे । ',
    OrganisationGroupsDescription:
      'संगठन के व्यवस्थापक: (संगठन के भीतर तैयार की गई सामग्री के लिए: निजी, सार्वजनिक, संगठन, समूह, विशिष्ट उपयोगकर्ता): यह पाठ्यक्रम [इवेंट |असेसमेंट] सहेजा जा चूका और निजी रखा गया है। । इसका मतलब है कि केवल आप (और कंटेंट क्रिएटर) इस सामग्री को देख सकते हैं। इस सामग्री को प्रकाशित करने के लिए आप नीचे दिए गए विकल्पों में से एक का चयन कर सकते हैं। अपने पाठ्यक्रम को सार्वजनिक रूप से प्रकाशित करने का अर्थ है कि अब यह प्लेटफ़ॉर्म पर मौजूद सभी उपयोगकर्ताओं के लिए उपलब्ध होगा - जिसमें आपके संगठन से बाहर के लोग भी शामिल होंगे। इसे संगठन के समक्ष प्रकाशित करने का अर्थ है कि संगठन के भीतर के सभी उपयोगकर्ता इसे देख पाएंगे। आप इसे 1 या अधिक समूहों के बीच भी प्रकाशित कर सकते हैं, जिसका अर्थ है कि केवल उन समूहों के उपयोगकर्ता ही इसे देख पाएंगे। अंत में, आपके पास अपने संगठन के भीतर और बाहर के विशिष्ट उपयोगकर्ताओं के साथ  साझा करते हुए उनके खाता ईमेल पते का उपयोग करके इसे प्रकाशित करने का विकल्प है। ',
    SpecificUsersDescription: `पेड़ स्वतंत्र उपयोगकर्ता: (निजी, सार्वजनिक और विशिष्ट उपयोगकर्ता) आपका [कोर्स | इवेंट | असेसमेंट] सहेजा गया है और डिफ़ॉल्ट रूप से निजी माना जाता है। इसका 'पेड़ स्वतंत्र उपयोगकर्ता: (निजी, सार्वजनिक और विशिष्ट उपयोगकर्ता) आपका [कोर्स | इवेंट | असेसमेंट] सहेजा गया है और डिफ़ॉल्ट रूप से निजी माना जाता है। इसका मतलब है कि केवल आप इस सामग्री को देख सकते हैं। इस सामग्री को प्रकाशित करने के लिए आप नीचे दिए गए विकल्पों में से एक का चयन कर सकते हैं। अपने पाठ्यक्रम को सार्वजनिक रूप से प्रकाशित करने का अर्थ है कि यह मंच के सभी उपयोगकर्ताओं के लिए उपलब्ध होगा। विशिष्ट उपयोगकर्ता विकल्प आपको अपने साझाकरण खाते से जुड़े ईमेल पते का उपयोग करके विशिष्ट उपयोगकर्ताओं के साथ अपना पाठ्यक्रम साझा करने में मौका देता है। ',मतलब है कि केवल आप इस सामग्री को देख सकते हैं। इस सामग्री को प्रकाशित करने के लिए आप नीचे दिए गए विकल्पों में से एक का चयन कर सकते हैं। अपने पाठ्यक्रम को सार्वजनिक रूप से प्रकाशित करने का अर्थ है कि यह मंच के सभी उपयोगकर्ताओं के लिए उपलब्ध होगा। विशिष्ट उपयोगकर्ता विकल्प आपको अपने साझाकरण खाते से जुड़े ईमेल पते का उपयोग करके विशिष्ट उपयोगकर्ताओं के साथ अपना पाठ्यक्रम साझा करने में मौका देता है। `
  },

  quiz: {
    quiz_empty: 'आपने अभी तक क्विज क्रिएट नहीं की है',
    questions_empty: 'आपने अभी तक सवाल नहीं बनाया है'
  },

  regions: {
    asia_pacific_australia: 'ऑस्ट्रेलिया',
    asia_pacific_india: 'भारत',
    asia_pacific_japan: 'जापान',
    asia_pacific_s_korea: 'दक्षिण कोरिया',
    asia_pacific_singapore: 'सिंगापुर',
    asia_pacific_taiwan: 'ताइवान',
    eu_belgium: 'बेल्जियम',
    eu_germany: 'जर्मनी',
    eu_ireland: 'आयरलैंड',
    south_america_brazil: 'ब्राज़ील',
    us_central_iowa: 'लोवा',
    us_east_s_carolina: 'दक्षिण कैरोलिना',
    us_east_virginia: 'वर्जिनिया',
    us_west_california: 'कैलिफ़ोर्निया',
    us_west_oregon: 'ऑरेगोन'
  },

  reports: {
    title: 'रिपोर्ट',
    workshop_report: 'वर्कशॉप रिपोर्ट',
    user_report: 'यूजर रिपोर्ट ',
    organization_workshop: 'संगठन की वर्कशॉप ',
    course: 'कोर्स',
    live_event: 'लाइव इवेंट',
    workShop_graph: 'वर्कशॉप ग्राफ',
    organization_account: ' संगठन का खाता ',
    all: 'सभी',
    name: 'नाम',
    id_number: 'आइडी नंबर',
    email: 'ईमेल',
    search_user_report: 'यूजर रिपोर्ट ढूंढे',
    participant: 'प्रतिभागी',
    participants: 'प्रतिभागी',
    host: 'मेज़बान',
    username: 'यूजर का नाम',
    event: 'इवेंट',
    quiz: 'प्रश्नोत्तरी ',
    assessment: 'मूल्यांकन',
    time: ' समय ',
    no_recent_activity: 'कोई हालिया गतिविधि नहीं',
    workshops: 'वर्कशॉप',
    courses: 'कोर्स',
    live_events: 'लाइव इवेंट',
    live_assessments: 'लाइव मूल्यांकन',
    quizzes: 'प्रश्नोत्तरी ',
    overview: 'ओवरव्यू',
    by: 'द्वारा',
    views: 'व्यूज',
    status: 'स्टेटस ',
    poll: 'पोल',
    comment: 'टिप्पणियाँ',
    comments: 'टिप्पणियाँ',
    no_comments: 'कोई टिप्पणियाँ नहीं',
    no_polls: 'कोई पोल नहीं',
    live_date: 'लाइव तारीख',
    score: 'स्कोर',
    question: 'प्रश्न',
    submit: 'जमा करे',
    recent_activity: 'हाल की गतिविधि',
    ago: 'पहले',
    no_data_found: 'कोई डेटा नहीं मिला',
    start_end_live: 'प्रारंभ / अंत लाइव का',
    join_leave_date: 'जुड़े/बाहर निकले',
    watched_time: 'जितनी देर देखा',
    complete: 'पूर्ण',
    in_complete: 'अधूरा',
    today: 'आज',
    seven_days: '7 दिन',
    last_month: 'पिछला माह',
    one_year: '1 साल',
    all_time: 'पूर्ण समय',
    report: 'रिपोर्ट',
    from_date: 'इस तारीख से',
    to_date: 'इस तारीख तक',
    all_workshop: 'सभी वर्कशॉप',
    all_participants: 'सभी प्रतिभागी',
    live_assessment: 'लाइव मूल्यांकन',
    users: 'यूज',
    download: 'डाउनलोड',
    recent: 'हाल का',
    WorkShop: 'वर्कशॉप',
    Activity: 'गतिविधि',
    created_date: 'बनाने की तारीख',
    lessons: 'पाठ',
    lesson: 'पाठ',
    completed: 'पूर्ण',
    report_download: 'रिपोर्ट डाउनलोड',
    this_month: 'इस माह',
    search_course: 'कोर्स ढूंढे',
    participants_graph: 'प्रतिभागी का ग्राफ',
    viewed: 'देखा गया',
    enrolled: 'एनरोल किया',
    description: 'विवरण',
    topic: 'विषय',
    analytic: 'विश्लेषणात्मक',
    quiz_list: 'प्रश्नोत्तरी की सूची',
    select_one: 'एक चुनो',
    group_status: 'ग्रुप स्टेटस',
    duration_min: 'अवधि (मिनट)',
    submit_poll: 'वोट करे',
    download_events: 'इवेंट डाउनलोड करे',
    search_event: 'इवेंट खोजे',
    duration: 'अवधि ',
    total_participants: 'कुल प्रतिभागी',
    message: 'संदेश',
    avg_message: 'औसत संदेश',
    per_message: 'औसत मैसेजेस / ईवेंट'
  },

  signup: {
    success_step1:
      'हमने आपके द्वारा दिए गए पते पर एक सत्यापन कोड ईमेल किया है, कृपया अपने पंजीकरण की पुष्टि करने के लिए नीचे दिए गए खाली स्थान में वो कोड कॉपी करें।',
    success_step2: 'धन्यवाद। आपका सफलतापूर्वक पंजीकृत पूरा हैं।',
    privacy: `मैं शेयरलुक के <1> नियम और शर्तें </ 1> और <3> गोपनीयता नीति </ 3> से सहमत हूं।`
  },

  stream: {
    emotion_impressive: 'प्रभावशाली',
    emotion_unimpressive: 'प्रभावशाली नहीं है',
    message_not_started: 'जल्द आ रहा है',
    message_running: 'लाइव',
    message_processing:
      'हम वर्तमान में प्लेबैक के लिए लाइव रिकॉर्डिंग कर रहे हैं। कृपया वीडियो देखने और रेटिंग और फ़ीडबैक देने के लिए बाद में वापस देखें '
  },

  tabs: {
    audience: 'दर्शक',
    course: 'कोर्स ओवरव्यू',
    details: 'लाइव इवेंट का विवरण',
    description: 'विवरण',
    host: 'होस्ट',
    lesson: 'पाठ ओवरव्यू',
    lessons: 'पाठ ',
    overview: ' ओवरव्यू ',
    page: 'पेज बिल्डर',
    publish: 'प्रकाशित करें',
    settings: 'प्रकाशित करने हेतु सेटिंग',
    total_views: 'कुल व्यू',
    live_participates: 'लाइव प्रतिभागी',
    live_chats: 'लाइव चैट',
    live_quiz: 'लाइव पोल',
    trainer_rating: 'ट्रेनर रेटिंग',
    trainer_times: 'ट्रेनर टाइम',
    courses_quizzes: 'पाठ्यक्रम क्विज़',
    user_list: 'उपयोगकर्ता सूची',
    discussion: 'चर्चा',
    notes: 'मेरे नोट्स'
  },

  topics: {
    SALES_TRAINING: 'बिक्री प्रशिक्षण',
    NEGOTIATION_TRAINING: 'मोलभाव प्रशिक्षण',
    CROSS_CULTURAL_AWARENESS: 'क्रॉस-कल्चरल अवेयरनेस',
    NETWORKING_SKILLS: 'नेटवर्किंग कौशल',
    SOFTWARE_ARCHITECTURE: 'सॉफ्टवेयर आर्किटेक्चर',
    PROJECT_MANAGEMENT: 'परियोजना प्रबंधन',
    DIGITAL_TRANSFORMATION: 'डिजिटल परिवर्तन',
    IT_CONSULTING: 'आईटी परामर्श',
    MANAGEMENT_CONSULTING: 'प्रबंधन परामर्श',
    HR_CONSULTING: 'मानव संसाधन परामर्श',
    INTERNET_OF_THINGS: 'इंटरनेट ऑफ थिंग्स',
    CYBERSECURITY: 'साइबर सुरक्षा',
    PRIVACY_AND_GDRP: 'गोपनीयता और जीडीपीआर'
  },

  training: {
    title: 'प्रशिक्षण',
    title_assessment: ' मूल्यांकन',
    subtitle: 'पाठ्यक्रम और लाइव इवेंट',
    enrolled_title: 'एनरॉल किए गए पाठ्यक्रम और लाइव इवेंट',
    enrolled_subtitle: 'पाठ्यक्रम और लाइव इवेंट जिसे आपने एनरॉल किया है',
    enrolled_message:
      'आप वर्तमान में किसी भी पाठ्यक्रम और घटनाओं में एनरॉल नहीं हैं।',
    past_live_event_title: 'पिछले लाइव इवेंट',
    past_live_event_subTitle: 'लाइव इवेंट समाप्त',
    past_live_event: 'वर्तमान में कोई भी लाइव इवेंट नहीं हैं।',
    recomended_title: ' सुझाये पाठ्यक्रम और लाइव इवेंट',
    now_live_event_title: 'अभी लाइव',
    now_live_event_subTitle: 'वे कार्यक्रम जो अभी लाइव हैं या बहुत जल्द होंगे',
    now_live_event: 'वर्तमान में कोई लाइव इवेंट नहीं है।',
    webinar_event_title: 'वेबिनार चैनल',
    webinar_event_subTitle: 'वेबिनार समाप्त',
    webinar_event: 'वर्तमान में कोई वेबिनार नहीं हैं।',
    p2p_event_title: 'कोचिंग सत्र',
    p2p_event_subTitle: 'कोचिंग सत्र समाप्त ',
    p2p_event: 'वर्तमान में कोचिंग सत्र नहीं हैं।',

    now_live_assessment_title: 'अब लाइव',
    now_live_assessment_subTitle:
      'मूल्यांकन जो अभी लाइव चल रहे है या आगे होने वाले है',
    now_live_assessment_message: 'वर्तमान में कोई लाइव मूल्यांकन नहीं है।',

    upcoming_assessment_title: 'आगामी लाइव मूल्यांकन ',
    upcoming_assessment_subtitle: 'आगामी लाइव मूल्यांकन',
    upcoming_assessment_message:
      'वर्तमान में कोई आगामी लाइव मूल्यांकन नहीं है।',

    past_live_assessment_title: 'पिछला लाइव मूल्यांकन ',
    past_live_assessment_subTitle: 'लाइव मूल्यांकन समाप्त ',
    past_live_assessment_message: 'वर्तमान में कोई पिछले लाइव आकलन नहीं हैं।',
    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'हमने आपके <0><0/></0> आधार पर पाठ्यक्रमों और लाइव घटनाओं को क्यूरेट किया है ',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'खोज प्रशिक्षण',
    search_assessment: 'खोज आकलन',
    recomended_message: 'वर्तमान में कोई अनुशंसित पाठ्यक्रम और ईवेंट नहीं हैं।'
  },

  warnings: {
    delete: 'क्या आपको यकीन है?'
  },

  workshop: {
    title: 'माई वर्कशॉप',
    subtitle: 'एक पाठ्यक्रम बनाएं या अपनी खुद की एक लाइव घटना की मेजबानी करें',
    new_course: 'एक नया पाठ्यक्रम बनाएं',
    new_event: 'एक नया लाइव ईवेंट बनाएं',
    new_assessment: 'एक नया लाइव मूल्यांकन बनाएं',
    courses_title: 'निर्मित पाठ्यक्रम और लाइव इवेंट',
    courses_subtitle:
      'अपना बनाया गया पाठ्यक्रम संपादित और प्रकाशित करें और लाइव इवेंट की योजना बनाएं',
    tags_course: 'कोर्स',
    tags_live: 'लाइव इवेंट',
    tags_assessment: 'लाइव असेसमेंट'
  },

  help_center: {
    sidebar: {
      title: 'हम आपकी कैसे मदद कर सकते हैं?',
      back_to: 'डैशबोर्ड'
    },
    menu: {
      help_center: 'सहायता केंद्र',
      whats_new: 'नया क्या है',
      feedback: 'फ़ीडबैक',
      feedback_title: ' शेयरलूक को फ़ीडबैक भेजें',
      terms_and_conditions: 'नियम और शर्तें',
      privacy_policy: 'गोपनीयता नीति',
      contact_us: 'हमसे संपर्क करें'
    },
    get_started: {
      title: 'शेयर लुक से शुरू करें',
      description: {
        main: 'हमे लाइव वीडियो को आसान कोर्स बिल्डर में शामिल कर दिया है',
        tagline:
          'शेयरलूक के पेटेंट लाइव प्रसारण प्रणाली के साथ, आप इंगेजमेंट, स्वचालित रूप से सीखना और साथ ही अपने ज्ञान को दुसरो के साथ साझा कर सकते हैं।'
      }
    },
    whats_new: {
      title: 'शेयर लुक से शुरू करें',
      description: {
        main:
          'क्या आप जानते हैं कि स्टोरीटेलिंग स्टाइल सीखना कम समय में सम्भव और वो भी आपके बजट में ? बीएस आपको शेयरलुक कोर्स बिल्डर और संबंधित प्रतिभाओं को जोड़ना होगा । आप हमसे पूछ सकते हैं कैसे',
        tagline: ''
      }
    },
    create_workshop: ' एक कार्यशाला कैसे बनाये',
    create_course: 'कैसे एक पाठ्यक्रम कैसे बनाये',
    create_user: 'यूजर कैसे क्रिएट करे',
    create_group: 'ग्रुप कैसे बनाएं',
    create_webinar: 'वेबिनार कैसे बनाएं',
    create_live_event: 'लाइव इवेंट कैसे बनाएं',
    create_live_assessment: 'लाइव आकलन कैसे करे',
    create_live_on_mobile: 'मोबाइल पर लाइव बनाएं',
    personalize_profile: 'एक प्रोफ़ाइल को निजीकृत करें',
    manage_group: 'समूह प्रबंधित करें',
    report: 'रिपोर्ट',
    add_annotations: 'एनोटेशन / पॉपअप कैसे जोड़ें',
    add_audio: 'ऑडियो कैसे जोड़ें',
    add_header_and_footer: 'हैडर और फुटर जोड़ना',
    add_image: 'छवि कैसे जोड़ें',
    add_quiz_content: 'प्रश्नोत्तरी सामग्री कैसे जोड़ें',
    add_text_content: 'पाठ सामग्री कैसे जोड़ें',
    add_user: 'उपयोगकर्ता कैसे जोड़ें',
    add_video: 'वीडियो कैसे जोड़ें',
    clone_course: 'हाउ टू क्लोन कोर्स',
    find_live_broadcast: 'लाइव प्रसारण कैसे खोजें',
    contact_us: {
      title: 'हमसे संपर्क करें',
      subject_placeholder: 'एक विषय दर्ज करें *',
      content_placeholder: 'एक संदेश दर्ज करें *',
      subject_required: '* विषय आवश्यक है',
      content_required: '* संदेश आवश्यक है',
      submit: 'भेजें',
      cancel: 'रद्द करें',
      sent: 'भेजा गया'
    },
    feedback: {
      title: 'साझा करने के लिए प्रतिक्रिया भेजें',
      attach_title: 'एक फाइल संलग्न करें',
      choose: 'फ़ाइल चुनें',
      detail: 'फाइल को सपोर्ट टीम के साथ साझा किया जाएगा',
      content_placeholder: ' एक संदेश दर्ज करें*',
      content_required: '* संदेश आवश्यक है',
      submit: 'भेजें',
      cancel: 'रद्द करें',
      sent: 'भेजा गया'
    }
  },
  discussion: {
    join_discussion: 'चर्चा में शामिल हों'
  },
  notes: {
    title: 'मेरे नोट्स',
    add_note: 'नया नोट जोड़ें'
  }
}
